var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7269\u8054\u8BBE\u5907") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-404.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7269\\u8054\\u8BBE\\u5907",
    transform: "translate(404.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70374873,1 C4.31855261,1 3.25928499,2.19167607 3.25928499,3.75002171 L3.25928499,27.5835432 C3.25928499,29.1418888 4.31855261,30.3335649 5.70374873,30.3335649 L27.3335649,30.3335649 C28.4381344,30.3335649 29.3335649,29.4381344 29.3335649,28.3335649 L29.3335649,3 C29.3335649,1.8954305 28.4381344,1 27.3335649,1 L5.70374873,1 L5.70374873,1 Z M11.4981215,24.0635485 L6.00344396,24.0635485 L6.00344396,22.433906 L11.4981215,22.433906 L11.4981215,24.0635485 Z M19.0278647,24.0664641 L13.5331872,24.0664641 L13.5331872,22.4136904 L15.6700063,22.4136904 L15.6700063,15.4131773 L10.5823419,15.4131773 C9.97182217,15.4131773 9.36130244,15.8754872 9.36130244,16.5227211 L9.36130244,22.4136904 L8.14026299,22.4136904 L8.14026299,16.5227211 C8.14026299,15.3207153 9.25954915,14.3036334 10.5823419,14.3036334 L15.6700063,14.3036334 L15.6700063,8.47852835 L11.3963682,8.47852835 L11.3963682,6.62928864 L21.1646838,6.62928864 L21.1646838,8.47852835 L16.8910457,8.47852835 L16.8910457,14.3036334 L21.8769568,14.3036334 C23.1997495,14.3036334 24.3190357,15.4131773 24.3190357,16.6151831 L24.3190357,22.4136904 L23.0979962,22.4136904 L23.0979962,16.6151831 C23.0979962,16.0604112 22.5892298,15.4131773 21.8769568,15.4131773 L16.8910457,15.4131773 L16.8910457,22.4136904 L19.0278647,22.4136904 L19.0278647,24.0664641 Z M26.557608,24.0635485 L21.0629305,24.0635485 L21.0629305,22.433906 L26.557608,22.433906 L26.557608,24.0635485 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.2fa7740ac2ea0e8c868e65c1b2cf8d59.svg";
export { ForwardRef as ReactComponent };